import React from "react"
import {routeConstants} from "../../constants/RouteConstants";
import {apiConstants} from "../../constants/ApiConstants";
import Table from "../../components/containers/Table";
import {keywordService} from "../../services/KeywordServices";

export function Keywords() {

  const columns = [
    {
      dataField: "id",
      text: "Ключевое слово",
      headerClasses: "text-nowrap",
      formatter: function (cell, row) {
        return row.keyword
      },
    },
    {
      dataField: "user",
      text: "Пользователь",
    },
    {
      dataField: "user",
      text: "Пользователь",
      classes: "action-bar",
      formatter: function (cell, row) {
        return (
          <div className="btn-group btn-group-sm action-group" role="group">
            <button onClick={() => {handleDelete(row.id)}} type="button" className="btn btn-danger delete" title="Удалить">
              <i className="fa fa-trash" />
            </button>
          </div>
        )
      }
    }
  ];

  const handleDelete = (id) => {
    keywordService.remove(id).then(() => {});
  }

  return (
    <Table
      sortField={"name"}
      dataUrl={apiConstants.API_URL + '/keywords'}
      columns={columns}
      title={"Ключевые слова"}
      addLink={routeConstants.PARSER_KEYWORD_ADD}
    />
  );
}